import {MSG_ERRO_SERVIDOR} from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
    mensagem:'',
    esperandoSolicitacao: false,
    erro: false
};

export default (state = INITIAL_STATE, action) => {
    
    switch (action.type){
        case 'CRER_IMPRESSAO_SOLICITADA':
            return {...state, esperandoSolicitacao: true,  mensagem: '', erro: false};

        case 'CRER_IMPRESSAO_RECEBIDA':
            return {...state, esperandoSolicitacao: false };

        case 'CRER_ERRO_IMPRESSAO_RECEBIDO':
            return {...state, esperandoSolicitacao: false, erro: true,
                mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR};

        case 'CRER_IMPRESSAO_NAO_ENCONTRADA':
                return {...state, esperandoSolicitacao: false,
                    mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR};
        default:
            return state;
    }
}
